import type { RouteRecordRaw } from 'vue-router'

import { MODELS_COMPARISON } from './routes-names'

export default (): RouteRecordRaw[] => {
  return [
    {
      path: 'compare',
      meta: {
        cache: 'public, max-age=300',
        tracking: { contentGroup: 'Comparison' },
      },
      children: [
        {
          name: MODELS_COMPARISON.HOME,
          path: 'home',
          component: () =>
            import('~/scopes/models-comparison/pages/Home/Home.vue'),
          meta: {
            owners: ['bot-squad-acquisition-front'],
          },
        },
        {
          name: MODELS_COMPARISON.CATEGORY,
          path: ':category',
          component: () =>
            import('~/scopes/models-comparison/pages/Search/Search.vue'),
          meta: {
            owners: ['bot-squad-acquisition-front'],
          },
        },
        {
          path: ':productA/:productB',
          component: () =>
            import('~/scopes/models-comparison/pages/Results/ResultsLayout.vue'),
          meta: {
            owners: ['bot-squad-acquisition-front'],
            // Stable key keeps this layout mounted across product-param changes.
            key: 'comparison-results-layout',
          },
          children: [
            {
              name: MODELS_COMPARISON.RESULTS,
              path: '',
              component: () =>
                import('~/scopes/models-comparison/pages/Results/Results.vue'),
              meta: {
                owners: ['bot-squad-acquisition-front'],
              },
            },
          ],
        },
      ],
    },
  ]
}
